/** @jsxImportSource @emotion/react */
import { FC } from 'react';
import { Selectable } from '@zip/business-components';
import { useMerchantApplicationContext } from 'contexts/MerchantApplication.context';
import {
  AnnualSalesProps,
  StepComponentProps,
} from 'types/interfaces/sign-up/MerchantApplication.types';
import { StepIndex } from '../signUpConfig';
import {
  SignUpRadioStepConfig,
  SignUpRadioStepForm,
  useSignUpRadioStep,
} from './useSignUpRadioStep.module';

const config: SignUpRadioStepConfig<AnnualSalesProps> = {
  stepIndex: StepIndex.AnnualSales,
  selectionField: 'salesRange',
  requiredSelectionMessage: 'Please select an option',
  initialValues: {
    salesRange: '',
  },
};

export const AnnualSalesStepModule: FC<StepComponentProps> = ({
  provideSubmit,
  serverErrors,
}) => {
  const { formOptions } = useMerchantApplicationContext();
  const options: Selectable[] = (formOptions.AverageSalesPerYear ?? []).map(
    (answer) => ({ label: answer, value: answer })
  );
  const step = useSignUpRadioStep(config, options, {
    provideSubmit,
    serverErrors,
  });

  return <SignUpRadioStepForm {...step} />;
};

export default AnnualSalesStepModule;
